import { render, staticRenderFns } from "./ServiceObjectDetail.vue?vue&type=template&id=720f7b3b&scoped=true"
import script from "./ServiceObjectDetail.vue?vue&type=script&lang=js"
export * from "./ServiceObjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceObjectDetail.vue?vue&type=style&index=0&id=720f7b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f7b3b",
  null
  
)

export default component.exports